import React from 'react';
import PhoneNumber from '../../../../../../../components/PhoneNumber/PhoneNumber';

export const getTenantOptions = (flats) => {
  const repeatClients = new Map();

  return flats.reduce((acc, flat) => {
    const data = [];

    flat.clients.forEach((client) => {
      const isClientExist = repeatClients.get(client.id);

      if (isClientExist === undefined) {
        repeatClients.set(client.id, 'exist');

        const obj = {
          value: client.id,
          searchText: `${client.name}8${client.phone}`,
          content: (
            <span>
              {client.name && <span>{client.name}</span>}{' '}
              <PhoneNumber phoneNumber={client.phone} name={client.name} />
            </span>
          ),
        };

        data.push(obj);
      }
    });

    return acc.concat(data);
  }, []);
};
